<template>
  <body>
    <Header headerColor="black" />
    <CompanyContent />
    <Footer />
  </body>
</template>

<script>
import Header from "@/components/SharedComponents/Header.vue";
import CompanyContent from "@/components/Company/CompanyContent.vue";
import Footer from "@/components/SharedComponents/Footer.vue";

export default {
  name: "sustainability",
  components: {
    Header,
    Footer,
    CompanyContent,
  },
};
</script>
